import { Checkbox } from "antd";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { useSticky } from "react-table-sticky";
import { toast, ToastContainer } from "react-toastify";
// import CheckBox from "./ReactTableFiles/CheckBox";
// import ColumnFilter from "./ReactTableFiles/ColumnFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
// import { common_axios } from "../../..";
import { common_axios } from "../../../App";
import CheckBox from "../Reacttable/UserManagement/ReactTableFiles/CheckBox";
import ColumnFilter from "../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import TableViewIcon from "@mui/icons-material/TableView";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";

const SingleTableEntry = ({ data1,resetValue }) => {
  const [data, setData] = useState([]);
  // console.log("data table------", data);

  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const [Status, setStatus] = useState("allUser");
  const [id, setId] = useState("");

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);

  const approveUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
    await modelButtonApprove.current.click();
  };

  const rejectUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetail(cell.row.original);
    await modelButtonReject.current.click();
  };



  const columns = useMemo(
    () => [
      {
        Header: "Mobile Number",
        Footer: "Mobile Number",
        accessor: "msisdn", // accessor is the "key" in the data
      },

      {
        Header: "Message",
        Footer: "Message",
        accessor: "message",
      },
      {
        Header: "Uploaded Date",
        Footer: "Uploaded Date",
        accessor: "uploadDate",
      },
      {
        Header: "Upto",
        accessor: "upto",
      },
    ],
    []
  );

  // console.log(Status, "lalalaallalas");

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };

  useEffect(() => {
    setData(data1);
  }, [data1]);
  useEffect(() => {
    setData([]);
  }, [resetValue]);
  return (
    <>
      <div>
        <div className="card-body p-0">
        {
          data.length>0 && (
            <><div className="container-fluid p-0">
            <div className="card shadow-none border bg_blue mt-5">
              <span className="badge rounded-pill bg-primary mt-n3 ms-5 ">
              DND Number List
              </span>
              <div className="p-4">
                <div>
                  {selectedFlatRows.length > 0 && (
                    <button onClick={deletUser}>Delete Users</button>
                  )}
                </div>

                <table
                  {...getTableProps()}
                  id="example"
                  className="table table-striped table-bordered dataTable table-sm"
                  style={{ width: "100%" }}
                >
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                          <th
                            {...column.getHeaderProps(
                              column.getSortByToggleProps()
                            )}
                            className="text-center width_2"
                          >
                            {column.render("Header")}
                            <span>
                              {column.isSorted
                                ? column.isSortedDesc
                                  ? "↑"
                                  : "↓"
                                : ""}
                            </span>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {page.map((row) => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map((cell) => {
                            return (
                              <td
                                {...cell.getCellProps()}
                                // className="text-center"
                                className={
                                          (cell.column.Header == "Mobile Number" )
                                             &&
                                          "text-end"
                                        }
                              >
                                {cell.render("Cell")}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div></>)}
          
        </div>
      </div>
    </>
  );
};

export default SingleTableEntry;
